module.exports = __webpack_public_path__ + "img/PtownTaxMap20211108.92b3b2c1.png";